const topicItems = [
  { label: '艺人税务', hot: true, count: '128篇' },
  { label: '直播翻车', hot: true, count: '96篇' },
  { label: '数据泄露', hot: true, count: '87篇' },
  { label: '选秀黑幕', hot: false, count: '74篇' },
  { label: '食品安全', hot: true, count: '143篇' },
  { label: '学术造假', hot: false, count: '58篇' },
  { label: '平台垄断', hot: false, count: '67篇' },
  { label: '医美乱象', hot: false, count: '76篇' },
  { label: '艺人合约', hot: false, count: '53篇' },
  { label: '金融违规', hot: false, count: '42篇' },
  { label: '隐私保护', hot: true, count: '91篇' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            当前最受关注的黑料事件话题标签，点击探索更多相关内容
          </p>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicItems.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="group inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer bg-background-50 border-background-200/60 hover:border-primary-300 hover:bg-primary-50"
            >
              {item.hot && (
                <span className="flex-shrink-0 w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}